function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { FaSort, FaSortUp, FaSortDown, FaEye, FaEdit, FaTrash } from "react-icons/fa";
import * as moment from "moment";
import "moment/locale/es";
import "../polizas/poliza.scss";
var STATUS_LABELS = {
  paid: "Pagado",
  overdue: "Vencido",
  current: "Al día",
  unknown: "Sin información"
};

var ListPolizaPayment = function ListPolizaPayment(props) {
  var payments = props.payments,
      sortField = props.sortField,
      sortOrder = props.sortOrder,
      onSort = props.onSort;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isSmallScreen = _React$useState2[0],
      setIsSmallScreen = _React$useState2[1];

  React.useEffect(function () {
    var check = function check() {
      return setIsSmallScreen(window.innerWidth <= 800);
    };

    check();
    window.addEventListener("resize", check);
    return function () {
      return window.removeEventListener("resize", check);
    };
  }, []);
  var columnFieldMap = {
    "Nº Póliza": "poliza.code.keyword",
    "Compañía": "poliza.company.name.keyword",
    "Contratante": "poliza.contratante.full_name.keyword",
    "Fin vigencia": "poliza.finish_date",
    "Forma de pago": "payment_type_name.keyword",
    "Nº Cuota": "quota_number",
    "Valor cuota": "amount_text.keyword",
    "Fecha vencimiento": "due_date",
    "Días atraso": "overdue_days",
    "Estado cuota": "overdue_status.keyword"
  };

  var getSortIcon = function getSortIcon(columnName) {
    var field = columnFieldMap[columnName];

    if (!field || !sortField || sortField !== field) {
      return /*#__PURE__*/React.createElement(FaSort, {
        style: {
          marginLeft: "4px",
          opacity: 0.4,
          fontSize: "12px"
        }
      });
    }

    return sortOrder === "asc" ? /*#__PURE__*/React.createElement(FaSortUp, {
      style: {
        marginLeft: "4px",
        color: "#2596be",
        fontSize: "14px"
      }
    }) : /*#__PURE__*/React.createElement(FaSortDown, {
      style: {
        marginLeft: "4px",
        color: "#2596be",
        fontSize: "14px"
      }
    });
  };

  var handleHeaderClick = function handleHeaderClick(columnName, e) {
    e.preventDefault();
    e.stopPropagation();
    var field = columnFieldMap[columnName];
    if (field && onSort) onSort(field);
  };

  var getHeaderStyle = function getHeaderStyle(width) {
    return {
      width: isSmallScreen ? "auto" : width,
      cursor: "pointer",
      userSelect: "none",
      whiteSpace: "normal",
      wordWrap: "break-word",
      padding: isSmallScreen ? "8px 4px" : "4px 8px"
    };
  };

  var getCellStyle = function getCellStyle(width) {
    return {
      width: isSmallScreen ? "auto" : width,
      padding: "4px 8px",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      whiteSpace: "normal"
    };
  };

  var formatDate = function formatDate(d) {
    if (!d) return "—";
    var m = moment(d);
    return m.isValid() ? m.format("DD/MM/YYYY") : "—";
  };

  var statusLabel = function statusLabel(status) {
    return STATUS_LABELS[status] || status;
  };

  var statusClass = function statusClass(status) {
    if (status === "paid") return "label label-success";
    if (status === "overdue") return "label label-danger";
    if (status === "current") return "label label-primary";
    return "label label-default";
  };

  var statusLabelStyle = {
    padding: "3px 6px",
    fontWeight: 600,
    fontSize: "11px",
    letterSpacing: "0.2px"
  };
  var baseUrl = "/admin";
  return /*#__PURE__*/React.createElement("div", {
    className: "table-responsive",
    style: {
      overflowX: "auto",
      overflowY: "visible",
      width: "100%",
      WebkitOverflowScrolling: "touch"
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-striped table-sm table-bordered cntListPoliza",
    style: {
      width: "100%",
      minWidth: isSmallScreen ? "100%" : "1400px",
      tableLayout: isSmallScreen ? "auto" : "fixed"
    }
  }, /*#__PURE__*/React.createElement("thead", {
    className: "tableHeader"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("8%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Nº Póliza", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "nowrap"
    }
  }, "N\xB0 P\xF3liza", getSortIcon("Nº Póliza"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("12%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Compañía", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Compa\xF1\xEDa y Ramo", getSortIcon("Compañía"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("14%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Contratante", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Contratante", getSortIcon("Contratante"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("7%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Fin vigencia", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Fin vigencia", getSortIcon("Fin vigencia"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("5%")), {}, {
      cursor: "default",
      backgroundColor: "#2596be",
      color: "white",
      fontWeight: "bold",
      padding: "8px 4px"
    })
  }, "Prima total"), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("5%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Forma de pago", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Forma de pago", getSortIcon("Forma de pago"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("4%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Nº Cuota", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "N\xBA Cuota", getSortIcon("Nº Cuota"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("10%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Valor cuota", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Valor cuota M/O", getSortIcon("Valor cuota"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("7%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Fecha vencimiento", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Fecha vencimiento", getSortIcon("Fecha vencimiento"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("7%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Días atraso", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "D\xEDas de atraso", getSortIcon("Días atraso"))), /*#__PURE__*/React.createElement("th", {
    style: _objectSpread(_objectSpread({}, getHeaderStyle("5%")), {}, {
      cursor: "pointer"
    }),
    onClick: function onClick(e) {
      return handleHeaderClick("Estado cuota", e);
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, "Estado cuota", getSortIcon("Estado cuota"))), /*#__PURE__*/React.createElement("th", {
    style: {
      width: "9%",
      backgroundColor: "#2596be",
      color: "white",
      fontWeight: "bold",
      padding: "8px 4px",
      cursor: "default"
    }
  }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
    className: "tableBody"
  }, payments.map(function (payment) {
    var _poliza$company, _poliza$contratante;

    var poliza = payment.poliza || {};
    var totalCuotes = poliza.number_of_cuotes;
    var cuotaDisplay = totalCuotes != null ? "".concat(payment.quota_number, "/").concat(totalCuotes) : String(payment.quota_number);
    return /*#__PURE__*/React.createElement("tr", {
      key: payment.id
    }, /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("8%")
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(baseUrl, "/polizas/").concat(payment.poliza_id)
    }, poliza.code || "—")), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("12%")
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        gap: "2px"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontWeight: 600
      }
    }, ((_poliza$company = poliza.company) === null || _poliza$company === void 0 ? void 0 : _poliza$company.name) || "—"), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "11px",
        color: "#555"
      }
    }, poliza.ramo || ""))), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("14%")
    }, ((_poliza$contratante = poliza.contratante) === null || _poliza$contratante === void 0 ? void 0 : _poliza$contratante.full_name) || "—"), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("7%")
    }, formatDate(poliza.finish_date)), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("5%")
    }, "\u2014"), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("5%")
    }, payment.payment_type_name || "—"), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("4%")
    }, cuotaDisplay), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("10%")
    }, payment.amount_text || "—"), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("7%")
    }, formatDate(payment.due_date)), /*#__PURE__*/React.createElement("td", {
      style: _objectSpread(_objectSpread({}, getCellStyle("7%")), {}, {
        verticalAlign: "middle",
        textAlign: "center"
      })
    }, payment.overdue_status === "overdue" && payment.overdue_days != null ? /*#__PURE__*/React.createElement("span", {
      className: "label label-danger",
      style: statusLabelStyle
    }, payment.overdue_days, " d\xEDas") : payment.overdue_status === "current" ? /*#__PURE__*/React.createElement("span", {
      className: "label label-success",
      style: statusLabelStyle
    }, "\u2014") : "—"), /*#__PURE__*/React.createElement("td", {
      style: _objectSpread(_objectSpread({}, getCellStyle("5%")), {}, {
        verticalAlign: "middle",
        textAlign: "center"
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: statusClass(payment.overdue_status),
      style: statusLabelStyle
    }, statusLabel(payment.overdue_status))), /*#__PURE__*/React.createElement("td", {
      style: getCellStyle("9%")
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "4px",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(baseUrl, "/poliza_payments/").concat(payment.id),
      className: "btn btn-info btn-xs",
      title: "Ver",
      style: {
        padding: "3px 6px",
        fontSize: "14px"
      }
    }, /*#__PURE__*/React.createElement(FaEye, null)), /*#__PURE__*/React.createElement("a", {
      href: "".concat(baseUrl, "/poliza_payments/").concat(payment.id, "/edit"),
      className: "btn btn-primary btn-xs",
      title: "Editar",
      style: {
        padding: "3px 6px",
        fontSize: "14px"
      }
    }, /*#__PURE__*/React.createElement(FaEdit, null)), /*#__PURE__*/React.createElement("a", {
      href: "".concat(baseUrl, "/poliza_payments/").concat(payment.id),
      "data-method": "delete",
      "data-confirm": "\xBFEst\xE1 seguro de eliminar este pago de p\xF3liza?",
      className: "btn btn-danger btn-xs",
      title: "Eliminar",
      style: {
        padding: "3px 6px",
        fontSize: "14px"
      }
    }, /*#__PURE__*/React.createElement(FaTrash, null)))));
  }))));
};

export default ListPolizaPayment;